// ImageKitImage
import React, { useState } from 'react';
import styles from './ImageKitImage.module.sass';
import { IKImage } from 'imagekitio-react';
import Icon from '../Icon';
import { getImageKiteEndPointAndPath } from 'utils/imageKit';

export interface ImageKitImageProps {
  path: string;
  alt?: string;
  videoPreview?: boolean;
  lazyLoad?: boolean;
  lqip?: boolean;
  quality?: number;
  transformation?: Array<Record<string, any>>;
}

const ImageKitImage: React.FC<ImageKitImageProps> = ({
  path,
  videoPreview = false,
  lazyLoad = true,
  lqip = true,
  transformation = [],
  quality = 80,
  ...props
}) => {
  const [hasError, setHasError] = useState(false);

  const { urlEndpoint, imageKitPath } = getImageKiteEndPointAndPath({
    path,
    videoPreview,
  });

  const onError = () => {
    setHasError(true);
  };

  // There are some paths that are saved in the bucket as `//influencer/...` instead of the correct `/influencer/...`
  // ImageKit does not properly handle those paths, so we use the regular Image component
  return (
    <span className={styles.ikWrapper}>
      {videoPreview && (
        <span>
          <Icon name="play-video" color="neutral04" />
        </span>
      )}
      {path.includes('.appspot.com//') || hasError ? (
        <ImageKitFallback path={path} videoPreview={videoPreview} />
      ) : path.includes('_thumbnail.jpeg') ? (
        <img alt="video thumbnail" src={path} {...props} />
      ) : (
        <IKImage
          urlEndpoint={urlEndpoint}
          path={imageKitPath}
          loading={lazyLoad ? 'lazy' : undefined}
          transformation={[...transformation, { quality }]}
          lqip={{ active: lqip }}
          onError={onError}
          {...props}
        />
      )}
    </span>
  );
};

export default ImageKitImage;

const ImageKitFallback: React.FC<ImageKitImageProps> = ({
  videoPreview,
  path,
  ...props
}) =>
  videoPreview ? (
    <video {...props} controls={false}>
      <source src={`${path}#t=0.001`} />
    </video>
  ) : (
    <img alt="image" src={path} {...props} />
  );
